import { Setting } from '../../interfaces/Setting';
import { SettingsActionTypes, Types } from '../types/types';

const initialSettings: Setting = {
  navCollapsed: false,
  initialPath: '/',
};

const settingsReducer = (state = initialSettings, action: SettingsActionTypes) => {
  switch (action.type) {
    case Types.ROUTE_CHANGE:
      return {
        ...state,
        navCollapsed: false,
      };

    case Types.TOGGLE_NAV_COLLAPSED:
      return {
        ...state,
        navCollapsed: !state.navCollapsed,
      };

    case Types.SET_INITIAL_PATH:
      return {
        ...state,
        initialPath: state.initialPath,
      };

    default:
      return state;
  }
};

export default settingsReducer;
